export default class MembershipType {
  constructor($module) {
    this.$module = $module;

    const cardRadios = Array.from(
      document.querySelectorAll('input[type=radio][name="PaymentMethod"]')
    );
    const radiosAll = Array.from(
      document.querySelectorAll('input:not([name="ProductName"])')
    );
    const productName = Array.from(
      document.querySelectorAll('input[type=radio][name="ProductName"]')
    );

    const cardRadiosLength = Array.from(
      document.querySelectorAll('input[type=radio][name="PaymentLength"]')
    );
    const cardRadiosPrice = Array.from(
      document.querySelectorAll('input[type=radio][name="PaymentMethod"]')
    );
    const directDebitRadios = Array.from(
      document.querySelectorAll('input[type=radio][value="paymentType"]')
    );
    let directDebitRadio = Array.from(
      document.querySelectorAll('input[type=radio][name="paymentType"]')
    );
    let directDebitRadioParent = document.querySelectorAll(
      ".ip-membership-type__item[data-paymentmethod]"
    );

    const allGroups = Array.from(
      document.querySelectorAll("[data-paymentmethod]")
    );
    const productGroups = Array.from(
      document.querySelectorAll('input[type=radio][name="ProductName"]')
    );
    const allGroupLength = Array.from(
      document.querySelectorAll("[data-length]")
    );

    let button = document.querySelector(
      ".bc-button-column > .bc-button-column--membership"
    );
    let checkBox = document.querySelector(".bc-checkbox");

    productGroups.forEach((element) => {
      element.addEventListener("change", function () {
        handleProductChange();
      });
    });

    function hideAllGroupsAndDisableInputs() {
      allGroups.forEach((g) => {
        g.style.display = "none";
        g.querySelectorAll("input").forEach((x) =>
          x.setAttribute("disabled", "true")
        );
        directDebitRadios.forEach((x) => (x.checked = false));
      });
    }

    function clearRadios() {
      allGroups.forEach((g) => {
        g.style.display = "none";
      });
      allGroupLength.forEach((z) => {
        z.style.display = "none";
      });
      radiosAll.forEach((y) => {
        y.checked = false;
      });
      button.setAttribute("disabled", "disabled");
    }
    function hideAllGroupsLength() {
      allGroupLength.forEach((item) => {
        item.style.display = "none";
      });
      allGroups.forEach((g) => {
        g.style.display = "none";
        g.querySelectorAll("input").forEach((x) =>
          x.setAttribute("disabled", "true")
        );
        cardRadios.forEach((x) => (x.checked = false));
      });
    }

    function handleRadioChange() {
      cardRadios.forEach((radio) =>
        radio.addEventListener("change", () => {
          hideAllGroupsAndDisableInputs();
          setVisibility();
        })
      );
    }
    function handleRadiosChangeLength() {
      cardRadiosLength.forEach((radio) =>
        radio.addEventListener("change", () => {
          hideAllGroupsLength();
          setVisibilityLength();
        })
      );
    }

    function handleRadiosProduct() {
      productName.forEach((radioButton) =>
        radioButton.addEventListener("change", () => {
          clearRadios();
          checkBox.style.display = "none";
        })
      );
    }
    function handlePaymentLength() {
      if (cardRadiosLength.length === 1) {
        cardRadiosLength.forEach((radioButton) => (radioButton.checked = true));
        setVisibilityLength();
      }
    }
    function handleProductChange() {
      productGroups.forEach((radio) =>
        radio.addEventListener("change", () => {
          handlePaymentLength();
        })
      );
    }

    function init() {
      handleRadioChange();
      handleRadiosChangeLength();
      handleRadiosProduct();
      handlePaymentLength();
      handleProductChange();
    }
    function setVisibilityLength() {
      checkBox.style.display = "none";
      let selectedVal = cardRadiosLength.find((x) => x.checked)?.value;
      let selectedRadioLength = allGroupLength.find(
        (x) => x.getAttribute("data-length") === selectedVal
      );

      let selectedRadioLength2 = selectedRadioLength.querySelectorAll(
        ".bc-radios__item"
      );

      allGroupLength.forEach((z) => {
        z.style.display = "none";
      });
      cardRadios.forEach((x) => {
        x.checked = false;
      });
      if (selectedRadioLength != null) {
        if (selectedRadioLength2) {
          if (selectedRadioLength2.length === 1) {
            let input = selectedRadioLength.querySelector(
              ".bc-radios__item .bc-radios__input"
            );
            input.checked = true;
            setVisibility();
            directDebitRadios.forEach((x) => (x.checked = false));
          }
        }

        selectedRadioLength.style.display = "block";
        selectedRadioLength
          .querySelectorAll("input")
          .forEach((x) => x.removeAttribute("disabled"));
      }
    }
    function setVisibility() {
      checkBox.style.display = "none";
      let selectedValPrice = cardRadiosPrice.find((z) => z.checked)?.value;
      let selectedRadio = allGroups.find(
        (x) => x.getAttribute("data-paymentmethod") === selectedValPrice
      );

      let selectedRadioLength4 = selectedRadio.querySelectorAll(
        ".bc-radios__item"
      );

      if (selectedRadio != null) {
        selectedRadio.style.display = "block";
        checkBox.style.display = "block";
        selectedRadio
          .querySelectorAll("input")
          .forEach(
            (x) => x.removeAttribute("disabled"),
            button.setAttribute("disabled", "disabled")
          );
        directDebitRadio.forEach((x) => (x.checked = false));
      }
      if (selectedRadioLength4.length === 1) {
        let inputPrice = selectedRadio.querySelector(
          ".bc-radios__item .bc-radios__input"
        );
        inputPrice.checked = true;
        removedisbaledButtonIf();
      }
      removedisbaledButtonIf();
    }
    function removeDisabledButton() {
      allGroups.forEach((radio) => {
        radio.addEventListener("change", function () {
          button.disabled = false;
        });
      });
    }
    function removedisbaledButtonIf() {
      directDebitRadioParent.forEach((z) => {
        if (z.style.display === "block") {
          let directBlock = z.querySelectorAll(
            'input[type=radio][name="paymentType"]'
          );
          directBlock.forEach((g) => {
            if (g.checked !== true) {
              button.setAttribute("disabled", "true");
            } else {
              button.disabled = false;
              return;
            }
          });
        }
      });
    }

    removeDisabledButton();

    init();
  }
}
